<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary position-relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap pos-relative {{
			sectionclass
		}}"
	>
		<div class="o-stack__cell">
			<h5>
				{{ sectiontitle }}
				<span *ngIf="tableConfig && tableConfig.enableDownload && hasData" class="datatable-icon">
					<a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV()" target="_blank">
						<img *ngIf="downloadIcon" class="download-icon-svg" src="{{ downloadIcon }}" />
						<i class="fa fa-download" aria-hidden="true" *ngIf="!tableConfig.downloadPNGIcon && !downloadIcon"></i>
						<img
							*ngIf="tableConfig.downloadPNGIcon && !downloadIcon"
							class="download-icon-svg"
							src="../../../../../assets/images/Download_Icon_R7.svg"
						/>
					</a>
				</span>
			</h5>
		</div>
	</div>
	<div class="analytics-portlet-content ctv-featured-network-r1-portlet" *ngIf="hasData">
		<div class="list">
			<table class="donutTable">
				<tr class="network-headers" *ngIf="version == 'r8'">
					<td>
						<div class="tdContainer">
							<div class="network-icon-container">
								<div class="network-title">Network</div>
								<div class="network-details-container">
									<div></div>
									<div>Completion Rate</div>
								</div>
							</div>
						</div>
					</td>
				</tr>
				<tr>
					<td
						*ngFor="
							let network of featuredNetworks | paginate : { itemsPerPage: itemsPerPage, currentPage: p2 };
							index as i
						"
						[ngClass]="getClassName(i)"
					>
						<div class="tdContainer" *ngIf="version !== 'r7'">
							<div class="network-icon-container">
								<img class="ftr-network-logo" [src]="network.logoPath" />
								<div class="network-details-container">
									<div class="featured-network-name primary-color">{{ network.networkName }}</div>
									<div class="primary-color" *ngIf="version !== 'r8' && !isr103">
										{{ network.displayCompletionRate | number : '0.2-2' }}% Completion Rate
									</div>
									<div class="primary-color" *ngIf="version == 'r8'">
										{{ network.displayCompletionRate | number : '0.2-2' }}%
									</div>
									<div class="primary-color" *ngIf="isr103">
										{{ network.displayCompletionRate | number : '0.2-2' }}%
										<span class="completionRate"> Completion Rate </span>
									</div>
								</div>
							</div>
							<div class="progressbar" *ngIf="version !== 'r8'">
								<div class="primary-color-bg-right-gradient" [style.width.%]="network.displayCompletionRate"></div>
							</div>
						</div>
						<div class="networkContainer" *ngIf="version == 'r7'">
							<div class="progressbar-r7" [ngStyle]="{ 'background-color': getColorFromColorConfig(1, 0.5) }">
								<div
									[style.height.%]="network.displayCompletionRate"
									[ngStyle]="{ 'background-color': getColorFromColorConfig(1, 1) }"
								></div>
							</div>
							<div class="network-icon-container-r7">
								<img class="ftr-network-logo-r7" [src]="network.logoPath" />
								<div class="network-details-container-r7">
									<div class="featured-network-name-r7">{{ network.networkName }}</div>
									<div
										class="completionRate"
										[ngStyle]="{ color: colorPalette.primaryColor }"
										*ngIf="network.displayCompletionRate < 100"
									>
										{{ network.displayCompletionRate | number : '0.2-2' }}%
									</div>
									<div
										class="completionRate"
										[ngStyle]="{ color: colorPalette.primaryColor }"
										*ngIf="network.displayCompletionRate == 100"
									>
										100%
									</div>
									<div class="completionRatelabel">Completion Rate</div>
								</div>
							</div>
						</div>
					</td>
				</tr>
			</table>
			<pagination-template
				#p="paginationApi"
				(pageChange)="p2 = $event"
				[ngClass]="{ 'hide-pagination': featuredNetworks.length < itemsPerPage }"
			>
				<ul class="pager">
					<li [class.disabled]="p.isFirstPage()" class="goToFirst" style="float: left">
						<a (click)="p.setCurrent(1)">
							<i class="fa fa-step-backward icons"></i>
						</a>
					</li>
					<li [class.disabled]="p.isFirstPage()" class="goToPrevious" style="float: left">
						<a (click)="p.previous()">
							<i class="fa fa-angle-left icons" *ngIf="version !== 'r7'"></i>
							<p *ngIf="version == 'r7'">Previous</p>
						</a>
					</li>
					<li
						role="button"
						*ngFor="let page of p.pages"
						[class.current]="p.getCurrent() === page.value"
						class="pages"
						style="float: left"
					>
						<a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
							{{ page.label }}
						</a>
						<a *ngIf="p.getCurrent() === page.value">
							{{ page.label }}
						</a>
					</li>
					<li [class.disabled]="p.isLastPage()" class="goToNext" style="float: left">
						<a (click)="p.next()">
							<i class="fa fa-angle-right icons" *ngIf="version !== 'r7'"></i>
							<p *ngIf="version == 'r7'">Next</p>
						</a>
					</li>
					<li [class.disabled]="p.isLastPage()" class="goToLast" style="float: left">
						<a (click)="p.setCurrent(p.getLastPage())">
							<i class="fa fa-step-forward icons"></i>
						</a>
					</li>
				</ul>
			</pagination-template>
		</div>
	</div>
	<div class="analytics-portlet-content ctv-featured-network-r1-portlet" *ngIf="!hasData">
		<app-loader [showLoader]="showLoad"></app-loader>
		<div class="map-no-data">No Data to Display</div>
	</div>
</div>
